// extracted by mini-css-extract-plugin
export var option = "_4h-0";
export var optionCard = "_4h-f";
export var optionContent = "_4h-g";
export var optionIcon = "_4h-i";
export var optionIconBox = "_4h-h";
export var optionLabel = "_4h-j";
export var optionPill = "_4h-m";
export var optionPillBadge = "_4h-p";
export var optionPillIcon = "_4h-n";
export var optionPillLabel = "_4h-o";
export var optionRadio = "_4h-k";
export var optionRadioInner = "_4h-l";
export var optionReveal = "_4h-2";
export var optionRevealDelay0 = "_4h-3";
export var optionRevealDelay1 = "_4h-4";
export var optionRevealDelay10 = "_4h-d";
export var optionRevealDelay11 = "_4h-e";
export var optionRevealDelay2 = "_4h-5";
export var optionRevealDelay3 = "_4h-6";
export var optionRevealDelay4 = "_4h-7";
export var optionRevealDelay5 = "_4h-8";
export var optionRevealDelay6 = "_4h-9";
export var optionRevealDelay7 = "_4h-a";
export var optionRevealDelay8 = "_4h-b";
export var optionRevealDelay9 = "_4h-c";
export var optionSelected = "_4h-1";